import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/Snapshot`
//#region select数据源相关api
const GetStatusList = `${apiUrl}/GetStatusList`
const GetList = `${apiUrl}`
const Get = (id: number) => `${apiUrl}/${id}`
const GetHandle = (id: number) => `${apiUrl}/handle/${id}`
const PostHandle = `${apiUrl}/handle`
const PostAudit = `${apiUrl}/audit`
//#endregion
export const emptyUnitSnapshotAudit: UnitSnapshotAuditData = {
    Id: 0,
    SnapshotId: 0,
    HandleId: 0,
    AuditResult: 0,
    Comments: '',
    AttachType: 0,
    AttachGuid: ''
}
export const emptyUnitSnapshotHandle: UnitSnapshotHandleData = {
    Id: 0,
    SnapshotId: 0,
    ResponsiblityUnit: '',
    ResponsiblityPerson: '',
    HandleResult: '',
    Comments: '',
    Status: 0,

    UserName: ''
}
export const emptyUnitSnapshot: UnitSnapshotData = {
    Id: 0,
    UnitId: 0,
    CellPhone: '',
    Imei1: '',
    Imei2: '',
    Imsi: '',
    ShotDate: new Date(),
    Specification: '',
    ResponsiblityUnit: '',
    ResponsiblityPerson: '',
    Comments: '',
    Status: 0,
    StatusText: '',

    ListId: 0,
    UnitCode: '',
    UnitName: '',
    AttachType: 0,
    AttachGuid: '',

    HandleInfo: emptyUnitSnapshotHandle,
    ActionList: [],
    EmptyHandle: emptyUnitSnapshotHandle,
    EmptyAudit: emptyUnitSnapshotAudit
}
export interface UnitSnapshotData {
    Id: number
    UnitId: number
    CellPhone: string
    Imei1: string
    Imei2: string
    Imsi: string
    ShotDate: Date
    Specification: string
    ResponsiblityUnit: string
    ResponsiblityPerson: string
    Comments: string
    Status: number
    StatusText: string

    ListId: number
    UnitCode: string
    UnitName: string
    AttachType: number
    AttachGuid: string

    HandleInfo: UnitSnapshotHandleData
    ActionList: UnitSnapshotActionData[]

    EmptyHandle: UnitSnapshotHandleData
    EmptyAudit: UnitSnapshotAuditData
}
export interface UnitSnapshotHandleData {
    Id: number
    SnapshotId: number
    ResponsiblityUnit: string
    ResponsiblityPerson: string
    HandleResult: string
    Comments: string
    Status: number

    UserName: string
}
export interface UnitSnapshotActionData {
    Id: number
    SnapshotId: number
    ActionType: number
    ReferId: number
    Comments: string

    ActionTypeName: string
    UserName: string
}
export interface UnitSnapshotAuditData {
    Id: number
    SnapshotId: number
    HandleId: number
    AuditResult: number
    Comments: string
    AttachType: number
    AttachGuid: string
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}
export const getHandle = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetHandle(id)
    })
}
export const postHandle = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostHandle,
        data: form
    })
}
export const postAudit = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostAudit,
        data: form
    })
}